import { css as n } from "styled-components";
const o = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2016%2011'%20enable-background='new%200%200%2016%2011'%20xml:space='preserve'%3e%3cg%3e%3cpolygon%20fill='%23007B90'%20points='8,11%2016,2.44%2013.71,0%208,6.11%202.29,0%200,2.44%208,11%208,11%20'/%3e%3c/g%3e%3cg%20display='none'%3e%3c/g%3e%3c/svg%3e", c = {
  assets: {
    dropdownIcon: o
  },
  base: ({ theme: e }) => /* @__PURE__ */ n([
    "appearance:none;background-image:",
    ";background-position:right ",
    " center;background-repeat:no-repeat;background-size:auto 1.1rem;"
  ], `url("${e.components.select.assets.dropdownIcon}")`, e.space.sm)
};
export {
  c as default
};
